import React, { useEffect, useState } from 'react';
import { COLORS, Z_INDEXES } from '@constants';
import { Col, Row, Tooltip as AntdTooltip } from 'antd';
import { Icon } from '../Icon';

const formatTooltipText = (text) => {
    if (typeof text !== 'string') return text;

    const parts = text.split('\n');
    if (parts.length <= 1) return text;

    return parts.map((part, index) => (
        <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && <br />}
        </React.Fragment>
    ));
};

export const Tooltip = ({ title, trigger = 'click', children, ...props }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const tooltipContainerElement = document.querySelector('.ant-tooltip');
        if (tooltipContainerElement) {
            tooltipContainerElement.setAttribute('data-e2e', 'common_tooltip_content');
        }
    }, [open]);

    const formattedTitle = formatTooltipText(title);

    const tooltipTitle =
        trigger === 'click' ? (
            <Row gutter={16}>
                <Col data-e2e='common_tooltip_text'>{formattedTitle}</Col>
                <Col>
                    <Icon
                        size='16px'
                        color={COLORS.$white}
                        component={() => <Icon.CloseIcon />}
                        onClick={() => setOpen(false)}
                    />
                </Col>
            </Row>
        ) : (
            formattedTitle
        );

    return (
        <div data-e2e='common_tooltip'>
            <AntdTooltip
                zIndex={Z_INDEXES.TOOLTIP}
                title={tooltipTitle}
                trigger={trigger}
                open={open}
                onOpenChange={setOpen}
                {...props}
            >
                {children}
            </AntdTooltip>
        </div>
    );
};
